

































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import FileUpload from "vue-upload-component";
import { useNotifierStore } from "@/shared/store/notifier";
import { useRiskQuizScoreStore } from "@/admin/store/riskQuizScore";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { UserPermission } from "@/shared/types";

@Component({
  components: {
    FileUpload,
    GenericLoadingSpinner,
  }
})
export default class RiskQuizAgeRevisions extends Vue {
  file = null;
  isSubmitting = false;
  notifierStore = useNotifierStore();
  riskQuizScore = useRiskQuizScoreStore();
  rolePermissionsStore = useRolePermissionsStore();

  created () {
    this.riskQuizScore.loadRiskQuizAgeRevisions();
  }

  get isLoading () {
    return this.riskQuizScore.isLoadingRiskQuizAgeRevision;
  }

  tableHeadings = [
    {
      key: "range",
      label: "Score Range",
      thClass: "text-left",
    },
    {
      key: "ageRevision",
      label: "Age Revision",
      thClass: "text-left",
    }
  ];

  get tableFields () {
    if (!this.riskQuizScore.didLoadRiskQuizAgeRevision) {
      return [];
    }

    return this.riskQuizScore.riskQuizAgeRevisions.map(f => ({
      range: f.minScore + " to " + f.maxScore,
      ageRevision: f.ageRevision
    }));
  }
  get submitDisabled () {
    return this.isSubmitting || !this.file;
  }
  fileChange (file) {
    if (!file) return;
    this.file = (document.getElementById("file-asset") as any).files[0];
  }
  get fileNameDisplay (): string {
    return this.file ? this.file.name : "Click to select .csv file";
  }
  submit () {
    if (!this.file) return;
    if (this.isSubmitting) return;

    this.isSubmitting = true;

    this.riskQuizScore.processRiskQuizAgeRevisionFile({
      csv: this.file
    })
      .then(() => {
        this.notifierStore.setSuccess("Risk Quiz Age Scores have been processed");
        this.riskQuizScore.loadRiskQuizAgeRevisions();
      }).catch(() => null)
      .finally(() => {
        this.isSubmitting = false;
        this.file = null;
      });
  }

  get hasEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityDrvWealthRiskAgeReviEdit);
  }
}
